import React, { useState } from 'react';
import { useAuth } from '../../providers/auth_provider';
import { toast } from 'react-toastify';
import axios from 'axios';
import validator from 'validator';

export default function Security() {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState({ password: '', confirmPassword: '' });
    const { token } = useAuth();

    const validateForm = () => {
        let valid = true;
        const errors = {};

        if (!validator.isLength(password, { min: 8 })) {
            errors.password = 'Password must be at least 8 characters long.';
            valid = false;
        } 
        if (password !== confirmPassword) {
            errors.confirmPassword = 'Passwords do not match.';
            valid = false;
        }

        setErrors(errors);
        return valid;
    };

    const handlePasswordChange = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            const response = await axios.put(`${process.env.REACT_APP_API_URL}/admin/change/password`, {
                password,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`,
                },
            });
            toast.success(response.data.message);
        } catch (error) {
            toast.error(error.response?.data?.message || 'An error occurred');
        }
    };

    return (
        <div className="card mb-6">
            <h5 className="card-header">Change Password</h5>
            <div className="card-body">
                <form
                    onSubmit={handlePasswordChange}
                    className="fv-plugins-bootstrap5 fv-plugins-framework"
                    noValidate
                >
                    <div className="alert alert-warning alert-dismissible" role="alert">
                        <h5 className="alert-heading mb-1">
                            Ensure that these requirements are met
                        </h5>
                        <span>Minimum 8 characters long.</span>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="alert"
                            aria-label="Close"
                        />
                    </div>
                    <div className="row gx-5">
                        <div className="mb-3 col-12 col-sm-6 form-password-toggle">
                            <div className="input-group input-group-merge">
                                <div className="form-floating form-floating-outline">
                                    <input
                                        className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                        type="password"
                                        id="newPassword"
                                        name="newPassword"
                                        onChange={(e) => setPassword(e.target.value)}
                                        value={password}
                                        placeholder="············"
                                    />
                                    <label htmlFor="newPassword">New Password</label>
                                    {errors.password && (
                                        <div className="invalid-feedback">
                                            {errors.password}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="mb-3 col-12 col-sm-6 form-password-toggle">
                            <div className="input-group input-group-merge">
                                <div className="form-floating form-floating-outline">
                                    <input
                                        className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                                        type="password"
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        value={confirmPassword}
                                        placeholder="············"
                                    />
                                    <label htmlFor="confirmPassword">Confirm New Password</label>
                                    {errors.confirmPassword && (
                                        <div className="invalid-feedback">
                                            {errors.confirmPassword}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div>
                            <button
                                type="submit"
                                className="btn btn-success me-2 waves-effect waves-light"
                            >
                                Change Password
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}
